import { render } from "./digital-incorporation-form-pick-up.vue?vue&type=template&id=061e2aa1&scoped=true"
const script = {}

import "./digital-incorporation-form-pick-up.vue?vue&type=style&index=0&id=061e2aa1&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061e2aa1"]])

export default __exports__